import angular from 'angular';

class InstallationGroupsService {
    promise = null;
    groups = [];

    /* @ngInject */
    constructor(ApiService, vrmNotificationsService,vrmNotificationType,locale, $rootScope) {
        this.ApiService = ApiService;
        this.vrmNotificationsService = vrmNotificationsService;
        this.vrmNotificationType = vrmNotificationType;
        this.locale = locale;
        $rootScope.$on('logout', () => {
            this.promise = null;
            this.groups = [];
        });
    }

    async loadInstallationGroups() {
        this.promise = this.reloadInstallationGroups();
        return this.promise;
    }

    async reloadInstallationGroups() {
        const response = await this.ApiService.call2('/installations/groups/list', null, {method: 'GET'});
        this.groups = response.data.groups;
        return this.groups;
    }

    async createInstallationGroup(payload) {
        const {data} = await this.ApiService.call2(`/installations/groups/create`, payload);
        this.groups.push(data.group);
        return data.group;
    }

    async deleteInstallationGroup(idSiteGroup) {
        const {data} = await this.ApiService.call2(`/installations/groups/${idSiteGroup}/delete`, null, {method: 'DELETE'});
        if (data.success) {
            const index = this.groups.findIndex(group => group.idSiteGroup === idSiteGroup);
            if (index >= 0) {
                this.groups.splice(index, 1);
            }
        }
    }

    async removeInvite(idSiteGroup, email) {
        const payload = {
            email: email,
        };
        await this.ApiService.call2(`/installations/groups/${idSiteGroup}/delete-invite`, payload, {throwOnError: true});
        const group = this.groups.find(g => g.idSiteGroup === idSiteGroup);
        // Update local group entry
        if (group) {
            const index = group.invites.findIndex(member => member.email === email);
            if (index >= 0) {
                group.invites.splice(index, 1);
            }
        }
    }



    async patchInstallationGroup(idSiteGroup, payload) {
        const {data} = await this.ApiService.call2(`/installations/groups/${idSiteGroup}/patch`, payload);
        const {success, group} = data;
        if (success) {
            const index = this.groups.findIndex(group => group.idSiteGroup === idSiteGroup);
            if (index >= 0) {
                this.groups.splice(index, 1, group);
            } else {
                this.groups.push(group);
            }
            this.vrmNotificationsService.add({
                type: this.vrmNotificationType.SUCCESS,
                message: this.locale.getString('core.settings_saved')
            });
        }
    }

    async inviteUsersToGroup(idSiteGroup, payload) {
        await this.ApiService.call2(`/installations/groups/${idSiteGroup}/invite-user`, payload);
        await this.reloadInstallationGroups();
    }
}

angular.module('vrm.core').service('InstallationGroupsService', InstallationGroupsService);
